import { calculateCheckDigit, extractReceiptNumber } from '../order-utils';
/**
 * Pads a number string to 5 digits.
 */
export var padToFive = function (value) {
    return value ? value.toString().padStart(5, '0') : '';
};
// Helper function to format receiptDetails to match receiptNumber
export var formatReceiptDetails = function (details) {
    if (!details)
        return '';
    var _a = details.split('-'), registerPart = _a[0], transactionPart = _a[1]; // Split into parts
    var paddedRegisterNumber = registerPart ? padToFive(registerPart) : ''; // Pad register part
    var paddedTransactionId = transactionPart ? padToFive(transactionPart) : ''; // Pad transaction part
    return "".concat(paddedRegisterNumber, "-").concat(paddedTransactionId); // Reassemble formatted string
};
/**
 * Builds the receipt number for B2B customers.
 */
export var buildB2BReceiptNumber = function (registerNumber, transactionId, transactionIdWithCheckDigit, customerType, cpsDataSource) {
    var _a, _b;
    var transactionIdValue = (_a = transactionId === null || transactionId === void 0 ? void 0 : transactionId.toString()) !== null && _a !== void 0 ? _a : '';
    if (customerType === 'b2b' && cpsDataSource === 'CPS') {
        transactionIdValue = (_b = transactionIdWithCheckDigit === null || transactionIdWithCheckDigit === void 0 ? void 0 : transactionIdWithCheckDigit.toString()) !== null && _b !== void 0 ? _b : '';
    }
    else if (cpsDataSource === 'LSS' && transactionIdValue.length < 5) {
        transactionIdValue += calculateCheckDigit((registerNumber === null || registerNumber === void 0 ? void 0 : registerNumber.toString()) || '', transactionIdValue.padStart(4, '0'));
    }
    return "".concat(padToFive(registerNumber), "-").concat(padToFive(transactionIdValue));
};
/**
 * Builds the receipt number for B2C customers.
 */
export var buildB2CReceiptNumber = function (registerNumber, transactionId) {
    var requestedTransactionId = (transactionId === null || transactionId === void 0 ? void 0 : transactionId.toString()) +
        calculateCheckDigit((registerNumber === null || registerNumber === void 0 ? void 0 : registerNumber.toString()) || '', (transactionId === null || transactionId === void 0 ? void 0 : transactionId.toString().padStart(4, '0')) || '') || '';
    return "".concat(padToFive(registerNumber), "-").concat(padToFive(requestedTransactionId));
};
/**
 * Determines if the order matches by order number.
 */
var isOrderNumberMatch = function (order, orderNumbers, orderNumber) {
    var _a;
    var orderNumberValue = ((_a = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _a === void 0 ? void 0 : _a[0]) || order.orderNumber;
    return (!!orderNumberValue &&
        orderNumberValue === ((orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) || orderNumber));
};
/**
 * Determines if the order matches by receipt number.
 */
var isReceiptNumberMatch = function (order, requestedOrder, customerType, cpsDataSource) {
    if (customerType === 'b2b') {
        var receiptNumber_1 = buildB2BReceiptNumber(order.registerNumber, padToFive(order.transactionId), requestedOrder.transactionIdWithCheckDigit, customerType, cpsDataSource);
        return (receiptNumber_1 === formatReceiptDetails(requestedOrder.receiptDetails) &&
            order.grandTotalAmount === requestedOrder.totalAmount);
    }
    // b2c
    var b2cReceiptDetails = buildB2CReceiptNumber(requestedOrder.registerNumber, requestedOrder.transactionId);
    var receiptNumber = extractReceiptNumber((order === null || order === void 0 ? void 0 : order.receiptImageSting) || '') || '';
    return receiptNumber === b2cReceiptDetails;
};
/**
 * Retrieves the selected order detail from allOrderDetails.
 */
export var retrieveSelectedOrderDetail = function (requestedOrder, allOrderDetails, customerType, cpsDataSource) {
    if (cpsDataSource === void 0) { cpsDataSource = 'LSS'; }
    var orderNumbers = requestedOrder.orderNumbers, orderNumber = requestedOrder.orderNumber;
    return (allOrderDetails.find(function (order) {
        var _a;
        if (((_a = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _a === void 0 ? void 0 : _a[0]) || order.orderNumber) {
            return isOrderNumberMatch(order, orderNumbers, orderNumber);
        }
        return isReceiptNumberMatch(order, requestedOrder, customerType, cpsDataSource);
    }) || null);
};
